<template>
  <div class="hm-home">
    <div class="card">
      <div class="panel flex item-center flex-between">
        <div>
          <el-button size="small" type="primary" @click="groupOperation('add')"
            >新建考核组</el-button
          >
        </div>
        <div class="form-wrapper flex flex-1 flex-wrap flex-end mb20">
          <el-input
            class="mr10"
            size="small"
            clearable
            placeholder="请输入考核组名"
            v-model.trim="searchConditons.groupName"
            style="width: 150px"
          ></el-input>
          <el-button size="small" type="primary" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table mb20">
        <el-table stripe border :data="list" style="width: 100%">
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            width="50"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="groupName"
            label="考核组名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="leaderNum"
            label="考评人数"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="employeeNum"
            label="被考核人数"
          ></el-table-column>
          <el-table-column header-align="center" align="center" label="操作">
            <template slot-scope="scope">
              <div class="flex flex-center item-center">
                <el-button
                  :class="
                    scope.row.enabledState === 'no' ? 'success' : 'danger'
                  "
                  size="small"
                  type="text"
                  @click="stateOperation(scope.row)"
                >
                  {{ scope.row.enabledState === "no" ? "开启" : "关闭" }}
                </el-button>
                <div class="line"></div>
                <el-button
                  @click="groupOperation('edit', scope.row)"
                  class="blue"
                  size="small"
                  type="text"
                  >编辑</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="text-center">
        <el-pagination
          background
          layout="total,sizes,  prev, pager, next, jumper"
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          ref="pagination"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      width="1200px"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="140px"
      >
        <el-form-item label="考核组名称：" prop="groupName">
          <el-input
            size="small"
            placeholder="请输入考核组名称"
            v-model="ruleForm.groupName"
            maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="考评人与被考核人：" prop="roleList">
          <div class="mb20">
            <el-cascader
              clearable
              ref="cascader"
              v-model="selectedStore"
              :props="props"
              :show-all-levels="false"
              size="small"
              placeholder="请选择机构"
              class="mr10"
            ></el-cascader>
            <el-input
              size="small"
              class="mr10"
              clearable
              placeholder="请输入职员姓名/工号"
              v-model.trim="targetName"
            ></el-input>
            <el-button
              size="small"
              :disabled="!selectedStore.length && !targetName"
              type="primary"
              @click="searchTarget"
              >查询</el-button
            >
          </div>
          <hm-transfer
            transferMode="sendTarget"
            transferPage="examineGroup"
            background="danger"
            leftName="职员"
            rightName="考评人与被考核人"
            :leftOption="leftSendTargetList"
            ref="transfer"
            @hasCheckedGuider="hasCheckedGuider"
            :isEnable="false"
          ></hm-transfer>
        </el-form-item>
        <div class="flex flex-center">
          <el-button
            v-if="operationType !== 'view'"
            @click="save"
            size="small"
            type="primary"
            >保存</el-button
          >
          <el-button @click="closeDialog" size="small">关闭</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import HmTransfer from "@/components/HmEmployeeTransfer";
import { mapGetters } from "vuex";

export default {
  components: {
    HmTransfer
  },
  computed: mapGetters(["taskInfo"]),
  data() {
    const validRoleList = (rule, val, callback) => {
      const list = this.$refs.transfer.rightData;
      const masterList = list.filter(v => v.identity === "master");
      const subordinateList = list.filter(v => v.identity === "subordinate");
      if (!masterList.length) {
        return callback(new Error("请选择考评人"));
      }
      if (!subordinateList.length) {
        return callback(new Error("请选择被考核人"));
      }
      callback();
    };
    return {
      dialogVisible: false,
      selectedStore: [],
      leftSendTargetList: [],
      targetName: "",
      currentRow: {},
      operationType: "",
      ruleForm: {
        groupName: "",
        examineGroup: []
      },
      dialogTitle: "添加考核组",
      rules: {
        groupName: {
          required: true,
          message: "请输入制定目标名称",
          trigger: "blur"
        },
        roleList: {
          required: true,
          validator: validRoleList
        }
      },
      searchConditons: {
        groupName: ""
      },
      total: 0,
      currentPage: 1,
      list: [],
      pageSize: 10,
      employeeList: [],
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: async (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            const res = await this.$store.dispatch("queryOrganizationTree", {
              pageNo: 1,
              pageSize: 999,
              loginType: "store"
            });
            res.result.records.forEach(v => {
              v.leaf = Boolean(!v.isParent);
              v.value = v.orgCode;
              v.label = v.departName;
            });
            resolve(res.result.records);
          } else {
            const res = await this.$store.dispatch(
              "queryOrganizationListByParent",
              {
                parentId: data.treeStruct
              }
            );
            if (res.code === "0" && res.result) {
              res.result.forEach(v => {
                v.leaf = Boolean(!v.isParent);
                v.value = v.orgCode;
                v.label = v.departName;
              });
              resolve(res.result);
            } else {
              resolve([]);
            }
          }
        }
      }
    };
  },
  created() {},
  mounted() {
    if (this.taskInfo) {
      const { page } = this.taskInfo;
      if (page === "ExamineGroup") {
        this.dialogVisible = true;
        this.dialogTitle = "添加考核组";
      }
    }
    this.queryList();
    this.queryEmployee();
  },
  watch: {},
  methods: {
    async searchTarget() {
      const orgCode =
        this.selectedStore && this.selectedStore.length
          ? this.selectedStore[this.selectedStore.length - 1]
          : "";
      const { result } = await this.$store.dispatch("queryEmployee", {
        queryKey: this.targetName,
        loginType: "store",
        orgCode,
        pageSize: 99999,
        pageNo: 1
      });
      const { records } = result;
      if (records) {
        this.leftSendTargetList = records;
        this.leftBindGuider = records;
      }
    },
    resetRuleForm() {
      setTimeout(() => {
        this.ruleForm.groupName = "";
        this.$refs.transfer.rightData = [];
        this.$refs.transfer.leftData = [];
        this.$refs.transfer.leftChecked = [];
        this.$refs.ruleForm.resetFields();
      }, 0);
    },
    hasCheckedGuider(val) {
      this.$refs.guideTransfer.isEnable = val;
    },
    addGroup() {},
    async queryList() {
      const params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      Object.assign(params, this.searchConditons);
      const { result } = await this.$store.dispatch(
        "queryExamineGroupList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    async stateOperation(row) {
      const status = row.enabledState === "no" ? "开启" : "关闭";
      const result = await this.$confirm(`${status}字段?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        await this.$store.dispatch("changeGroupDetails", {
          id: row.id
        });
        this.queryList();
      }
    },
    async queryEmployee() {
      const { result } = await this.$store.dispatch("queryEmployee", {
        pageNo: 1,
        pageSize: 9999,
        loginType: "store",
        workingState: "yes"
      });
      this.employeeList = result.records;
    },
    async groupOperation(type, row) {
      this.dialogVisible = true;
      this.resetRuleForm();
      this.operationType = type;
      switch (type) {
        case "add":
          this.dialogTitle = "添加考核组";
          break;
        case "edit":
          this.currentRow = row;
          this.dialogTitle = "编辑考核组";
          this.queryGroupDetails(row);
          break;
        default:
          break;
      }
    },
    async queryGroupDetails(row) {
      const { result } = await this.$store.dispatch("queryGroupDetails", {
        id: row.id
      });
      this.ruleForm.groupName = result.groupName;
      result.leaderList.forEach(v => {
        v.identity = "master";
      });
      result.employeeList.forEach(v => {
        v.identity = "subordinate";
      });
      this.$refs.transfer.rightData = [
        ...result.leaderList,
        ...result.employeeList
      ];
      this.ruleForm = row;
    },
    async save() {
      const valid = await this.$refs.ruleForm.validate();
      if (valid) {
        const list = this.$refs.transfer.rightData;
        const leaderList = list
          .filter(v => v.identity === "master")
          .map(v => {
            return {
              employeeId: v.employeeId
            };
          });
        const employeeList = list
          .filter(v => v.identity === "subordinate")
          .map(v => {
            return {
              employeeId: v.employeeId
            };
          });
        let url = "addExamineGroup";
        const params = {
          groupName: this.ruleForm.groupName,
          leaderList,
          employeeList
        };
        if (this.operationType === "edit") {
          url = "editExamineGroup";
          Object.assign(params, {
            id: this.currentRow.id
          });
        }
        await this.$store.dispatch(url, params);
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.queryList();
        this.dialogVisible = false;
      }
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
.card {
  background: #fff;
  padding: 15px;
}
.table-panel {
  background: #fff;
  padding: 15px;
}

.table {
  .line {
    width: 1px;
    margin: 0 10px;
    height: 12px;
    background: #ddd;
  }
}

.details-dialog {
  .label {
    color: #000;
    font-weight: bold;
  }
}

.supervisedPerson-list {
  .person {
    margin-right: 50px;
    margin-bottom: 29px;
  }
  .store-name {
    color: #000;
    font-weight: bold;
  }
}
</style>
